import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  Modal,
  Table,
  Loader,
  Accordion,
  Popup,
} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';

class BackOrdersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
  }

  fetchData() {
    const {code} = this.props;
    this.props.fetchOnOrdersDetail(code);
    this.setState({'modalWasOpen': true});
  }

  getAccordionItems() {
    const {onOrdersDetail} = this.props;
    return [
      {
        'title': this.renderInTransitTitleSection(
          onOrdersDetail && onOrdersDetail.inTransit ?
            onOrdersDetail.inTransit :
            []
        ),
        'content': this.renderInTransitContentSection(
          onOrdersDetail && onOrdersDetail.inTransit ?
            onOrdersDetail.inTransit :
            []
        ),
        'key': 0,
      },
      {
        'title': this.renderConfirmedTitleSection(
          onOrdersDetail && onOrdersDetail.confirmed ?
            onOrdersDetail.confirmed :
            []
        ),
        'content': this.renderConfirmedContentSection(
          onOrdersDetail && onOrdersDetail.confirmed ?
            onOrdersDetail.confirmed :
            []
        ),
        'key': 1,
      },
    ];
  }

  renderInTransitTitleSection(list) {
    if (!list || list.length === 0) {
      return <div>No hay datos Disponibles de Pedidos en Tránsito</div>;
    }
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={8} textAlign='left'>
              Pedidos en Tránsito
            </Table.HeaderCell>
            <Table.HeaderCell width={3} textAlign='center'>
              Proceso
            </Table.HeaderCell>
            <Table.HeaderCell width={3} textAlign='center'>
              Llegada
            </Table.HeaderCell>
            <Table.HeaderCell width={2} textAlign='center'>
              {_.sumBy(list, 'quantity')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      </Table>
    );
  }

  renderInTransitContentSection(list) {
    if (!list || list.length === 0) {
      return <div />;
    }
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>{this.renderInTransitItems(list)}</Table.Body>
      </Table>
    );
  }

  renderInTransitItems(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell width={8} textAlign='left'>
            {element.orderCode}
          </Table.Cell>
          <Table.Cell width={3} textAlign='center'>
            {element.processDate ?
              moment(element.processDate).format(dateFormatReservation) :
              ''}
          </Table.Cell>
          <Table.Cell width={3} textAlign='center'>
            {element.arriveDate ?
              moment(element.arriveDate).format(dateFormatReservation) :
              ''}
          </Table.Cell>
          <Table.Cell width={2} textAlign='center'>
            {element.quantity}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderConfirmedTitleSection(list) {
    if (!list || list.length === 0) {
      return <div>No hay datos Disponibles de Facturas Confirmadas</div>;
    }
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={11} textAlign='left'>
              En Facturas Confirmadas
            </Table.HeaderCell>
            <Table.HeaderCell width={3} textAlign='center'>
              Llegada
            </Table.HeaderCell>
            <Table.HeaderCell width={2} textAlign='center'>
              {_.sumBy(list, 'quantity')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      </Table>
    );
  }

  renderConfirmedContentSection(list) {
    if (!list || list.length === 0) {
      return <div />;
    }
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>{this.renderConfirmedItems(list)}</Table.Body>
      </Table>
    );
  }

  renderConfirmedItems(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell width={11} textAlign='left'>
            {element.invoice}
          </Table.Cell>
          <Table.Cell width={3} textAlign='center'>
            {element.date ?
              moment(element.date).format(dateFormatReservation) :
              ''}
          </Table.Cell>
          <Table.Cell width={2} textAlign='center'>
            {element.quantity}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {quantity, quantityConfirmed, loading, onOrdersDetail} = this.props;
    const {modalWasOpen} = this.state;
    const existDataAfterCallApi =
      modalWasOpen && onOrdersDetail && onOrdersDetail.inTransit;

    if (
      (existDataAfterCallApi &&
        _.sumBy(onOrdersDetail.inTransit, 'quantity') === 0) ||
      !quantity
    ) {
      return (
        <div>
          <Popup
            trigger={<span>{0}</span>}
            content='Pedidos en Tránsito'
            position='top center'
            inverted
          />
          <Popup
            trigger={<span className='margin-left'>({quantityConfirmed})</span>}
            content='En Facturas Confirmadas'
            position='top center'
            inverted
          />
        </div>
      );
    }
    return (
      <Modal
        size='small'
        onOpen={() => this.fetchData()}
        trigger={
          <span className='link'>
            <Popup
              trigger={
                <span>
                  {existDataAfterCallApi ?
                    _.sumBy(onOrdersDetail.inTransit, 'quantity') :
                    quantity}
                </span>
              }
              content='Pedidos en Tránsito'
              position='top center'
              inverted
            />

            <Popup
              trigger={
                <span className='margin-left'>({quantityConfirmed})</span>
              }
              content='En Facturas Confirmadas'
              position='top center'
              inverted
            />
          </span>
        }
        closeIcon
      >
        <Modal.Header>
          On Orders
          <span className='quantity-container'>
            {existDataAfterCallApi ?
              _.sumBy(onOrdersDetail.inTransit, 'quantity') :
              quantity}
          </span>
        </Modal.Header>

        <Modal.Content scrolling>
          <Modal.Description>
            {loading && <Loader active inline='centered' />}
            {!loading && (
              <Accordion.Accordion
                defaultActiveIndex={[0, 1]}
                exclusive={false}
                panels={this.getAccordionItems()}
              />
            )}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partModals.loadingOnOrdersDetail,
    'onOrdersDetail': state.partModals.onOrdersDetail,
  };
};

const {fetchOnOrdersDetail} = Actions;

export default connect(mapStateToProps, {
  fetchOnOrdersDetail,
})(BackOrdersModal);
